import { flowRight as compose } from 'lodash';

const API_VERSION = globals.config.axios.baseURL;
const PLACEHOLDERS_ENDPOINT = '/placeholders';
const REGION_PREFIX = '/regions';
const CATEGORIES_ENDPOINT = '/categories';
const PRODUCT_ENDPOINT = '/products';
const CART_ENDPOINT = '/order';
const USERS_ENDPOINT = '/users';
const POLL_ENDPOINT = '/poll';

export function zipCode(code) {
    return `/users/zip/${ code }`;
}

export function subscribe() {
    return `/subscribe`;
}

export function category(id, cooperative) {
    return `${ REGION_PREFIX }/${ cooperative }${ CATEGORIES_ENDPOINT }/${ id }/children`;
}

export function categories(cooperative) {
    return `${ REGION_PREFIX }/${ cooperative }${ CATEGORIES_ENDPOINT }/`;
}

export function topicProducts(topicSlug) {
    return `/topics/${ topicSlug }`;
}

export function product(slug) {
    return `${ PRODUCT_ENDPOINT }/${ slug }`;
}

export function cart() {
    return `${ CART_ENDPOINT }/`;
}

export function cartItems() {
    return `${ CART_ENDPOINT }/items`;
}

export function orderExpiration() {
    return `${ CART_ENDPOINT }/expiration`;
}

export function poll(id) {
    return `${ POLL_ENDPOINT }/${ id }`;
}

export function placeholder(placeholderId) {
    return `${ PLACEHOLDERS_ENDPOINT }/${ placeholderId }`;
}

export function topProducts(categoryId, cooperative) {
    return `${ REGION_PREFIX }/${ cooperative }${ CATEGORIES_ENDPOINT }/${ categoryId }/top-products`;
}

export function orderDeliveryAddresses() {
    return `${ CART_ENDPOINT }/delivery-address`;
}

export function checkout() {
    return `${ CART_ENDPOINT }/checkout`;
}

export function promoCode() {
    return `${ CART_ENDPOINT }/promo-code`;
}

export function userAddresses() {
    return `${ USERS_ENDPOINT }/addresses`;
}

export function userCreditCard() {
    return `${ USERS_ENDPOINT }/credit-card`;
}

export function userFavoriteProducts() {
    return `${ USERS_ENDPOINT }/favorite-products`;
}

export function mostPurchasedProducts() {
    return `${ userFavoriteProducts() }/most-purchased`;
}

export function lastPurchasedProducs() {
    return `${ userFavoriteProducts() }/last-purchased`;
}

export function userAddressSetDefault() {
    return `${ USERS_ENDPOINT }/addresses/default`;
}

export function pendingOrders() {
    return `${ USERS_ENDPOINT }/orders/pending`;
}

export function finishedOrders() {
    return `${ USERS_ENDPOINT }/orders/finished`;
}

export function copyOrder(id) {
    return `${ USERS_ENDPOINT }/orders/${ id }/copy/`;
}

export function order(id) {
    return `${ USERS_ENDPOINT }/orders/${ id }`;
}

export function orderPickerRating(id) {
    return `${ USERS_ENDPOINT }/orders/${ id }/picker-rating`;
}

export function orderFeedback(id) {
    return `${ USERS_ENDPOINT }/orders/${ id }/feedback`;
}

export function replacementProducts() {
    return `${ USERS_ENDPOINT }/replacement-products`;
}

export function notifications() {
    return '/notifications';
}

export function pickers(limit = 100, chunkIndex = null) {
    return `${ CART_ENDPOINT }/pickers?limit=${ limit }${ chunkIndex === null ? '' : `&chunk_index=${ chunkIndex }` }`;
}

/*  urlParam: keyword (urlencoded)
*   getParams: offset, limit (int)
*/
export function search(keyword, cooperative) {
    return `${ REGION_PREFIX }/${ cooperative }/search/${ keyword }`;
}

/// There and back again
//  An endpoint's tale - forwarders require "/api" to be set explicitly

export function login(redirectToUrl = window.location) {
    return `/login?${ NEXT_PARAM }=${ redirectToUrl }`;
}

export function logout(url) {
    return `/logout?${ RETURN_TO_PARAM }=${ url }`;
}

export function userAddressEdit(id) {
    return `${ API_VERSION }${ USERS_ENDPOINT }/addresses/${ id }/edit?${ returnTo(window.location) }`;
}

export function userAddressAdd() {
    return `${ API_VERSION }${ USERS_ENDPOINT }/addresses/add?${ returnTo(window.location) }`;
}

export function userEdit() {
    return `${ API_VERSION }${ USERS_ENDPOINT }/edit?${ returnToAndForward('login', window.location.pathname) }`;
}

export function userConnectCumulus() {
    return `${ API_VERSION }${ USERS_ENDPOINT }/connect-cumulus?${ returnToAndForward('login', window.location.pathname) }`;
}

/**
 * Helper meethods needed for the mLogin redirects
 */

const RETURN_TO_PARAM = 'return_to';
const NEXT_PARAM = 'next';
const BASE_URL = `${ window.location.protocol }//${ window.location.host }/`;

const returnToAndForward = (path, query) => compose(returnTo, toAbsolute)(`${ path }${ nextQuery(query) }`);
const toAbsolute = path => `${ BASE_URL }${ path }`;
const returnTo = url => `${ RETURN_TO_PARAM }=${ url }`;
const nextQuery = query => encodeURIComponent(`?${ NEXT_PARAM }=${ query }`);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/api-urls.js